<template>
  <v-flex xs12 sm12 md12>
    <v-data-table
        :headers="headers"
        :items="orders"
        :loading="loading"
        item-key="id"
        class="elevation-1"
        hide-actions
        :hide-headers="isMobile"
        :class="{mobile: isMobile}"
        :sort-by="'id'"
        :sort-desc="true"
    >
      <template slot="headers" slot-scope="props">
        <tr>
          <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['text-xs-left column sortable', pagination.descending ? 'desc' : 'asc', ]"
          >
            <v-icon small>arrow_upward</v-icon>
            {{ header.text }}
          </th>
        </tr>
      </template>

      <template slot="items" slot-scope="props">
        <tr v-if="!isMobile">
          <td class="text-xs-center"># {{ props.item.id }}</td>
          <td class="text-xs-center">{{ props.item.user_name }}</td>
          <td class="text-xs-center">{{ props.item.phone }}</td>
          <td class="text-xs-center">{{ props.item.created | moment("MM/DD/YYYY") }}</td>
          <td class="text-xs-center">$ {{ props.item.total_amount }}</td>
          <td class="text-xs-center px-0" v-if="hasActionColumn">
            <v-btn
                color="success"
                class="text-capitalize"
                @click="doAction(props.item)"
            >
              <v-icon :class="'v-icon--left'"
                      dark small
              >fa-solid fa-lg fa-plus
              </v-icon>
              Receive
            </v-btn>
          </td>
          <td v-else class="text-xs-center">{{ props.item.date_received | moment("MM/DD/YYYY") }}</td>
        </tr>
        <tr v-else>
          <td>
            <ul class="flex-content">
              <li class="flex-item" data-label="Order #"># {{ props.item.id }}</li>
              <li class="flex-item" data-label="User">{{ props.item.user_name }}</li>
              <li class="flex-item" data-label="Phone">{{ props.item.phone }}</li>
              <li class="flex-item" data-label="Created">{{ props.item.created | moment("MM/DD/YYYY") }}</li>
              <li class="flex-item" data-label="Total amount">$ {{ props.item.total_amount }}</li>
              <li class="flex-item" data-label="Action" v-if="hasActionColumn">
                <v-btn
                    color="success"
                    class="text-capitalize"
                    :disabled="loading"
                    @click="doAction(props.item)"
                >
                  <v-icon class="v-icon--left"
                          :class="{'mr-2': !isMobile}"
                          dark small
                  >fa-solid fa-lg fa-plus
                  </v-icon>
                  <span class="hidden-xs-only">Receive</span>
                </v-btn>
              </li>
              <li v-else class="flex-item" data-label="Created">{{ props.item.date_received | moment("MM/DD/YYYY") }}</li>
            </ul>
          </td>
        </tr>
      </template>
      <template slot="no-data">
        Not data
      </template>
    </v-data-table>
    <v-flex mt-5>
      <v-layout row wrap align-center justify-center fill-height>
        <v-flex xs12 sm2 md2>
          <v-pagination
              color="#008EFF"
              v-model="paginationNext"
              :length="pagination.lastPage"
              :total-visible="pagination.visible"
              :value="pagination.page"
              light
              @input="paginationPage"
              prev-icon="keyboard_arrow_left"
              next-icon="keyboard_arrow_right"
          ></v-pagination>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-flex>
</template>

<script>

export default {
  name: 'OperatorTable',
  props: ['orders', 'pagination', 'headers'],
  data() {
    return {
      paginationNext: 1,
    }
  },
  methods: {
    paginationPage() {
      this.pagination.page = this.paginationNext
      this.getDataWalking()
    },
    getDataWalking() {
      this.$emit('getData');
    },
    doAction(item) {
      if (this.loading) {
        return;
      }
      this.$emit('doAction', item);
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    loading() {
      return this.$store.getters.loading;
    },
    hasActionColumn() {
      return Array.isArray(this.headers) && this.headers.some(header => header.value === 'action');
    }
  }
}
</script>

<style scoped lang="stylus">

.status-img-order
  margin-bottom -3px

.status-img
  margin-top -3px

.btn-order-block
  border-radius 6px
  width 9.375rem
  max-width 15rem
  min-width 12rem

.btn-order-block-disabled
  pointer-events auto
  cursor not-allowed !important

.header-order-block
  background-color #fff
  border-radius 6px

.title-order
  height 22px
  color #252A30
  font-family Roboto
  font-size 18px
  font-weight bold
  line-height 22px

.rounded-card
  border-radius 6px
  box-shadow 0 3px 4px 0 rgba(0, 0, 0, 0.08), 0 2px 8px 0 rgba(0, 0, 0, 0.12)

.rounded-card .qty-in-progress
  height 22px
  border-radius 4px
  background-color #F1F1F4

.qty-in-progress
  margin-left 0 !important

.rounded-card .qty-in-progress span
  color #008EFF
  height 14px
  font-family Roboto
  font-size 12px
  font-weight 500
  line-height 14px

.order-title
  height 22px
  color #252A30
  font-family Roboto
  font-size 18px
  font-weight bold
  line-height 22px

.order-number
  font-size 0.6em !important

.order-label
  height 18px
  opacity 0.54
  color #252A30
  font-family Roboto
  font-size 14px
  line-height 18px

.payment-text
  height 14px
  opacity 0.54
  color #000000
  font-family Roboto
  font-size 12px
  line-height 14px

.product-title
  height 18px
  width 151px
  color #252A30
  font-family Roboto
  font-size 14px
  font-weight 500
  line-height 18px

.price
  height 18px
  color #252A30
  font-family Roboto
  font-size 14px
  line-height 18px

.status-img-barcode
  height 20px

.qty
  height 18px
  color #252A30
  font-family Roboto
  font-size 14px
  line-height 18px

.v-card__text
  padding 0 !important

.header-order-block
  /*background-color gainsboro*/
  background-color #fff
  height 60px
  border-radius 6px 6px 0 0

.btn-view-name
  font-size 14px
  color black
  opacity 0.7

.status-img-order
  margin-bottom -5px

.order-number-height
  height 16px

.header-order-height
  height 60px

.block-btn-column
  margin-left -15px

</style>
<style>
.mobile {
  color: #333;
}
.plus300px {
  width: 300px;
}
@media screen and (max-width: 959px) {
  .plus300px {
    width: auto;
  }
}
@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid deeppink;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid #008eff;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: .5em;
    text-align: left;
    display: block;
    color: #999;
  }
  .v-datatable__actions__select
  {
    width: 50%;
    margin: 0;
    justify-content: flex-start;
  }
  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }

}
.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;
  width: 50%;
  min-height: 40px;
  font-weight: bold;
}
</style>
